export enum SupplierInvoiceStatusEnum {
  INVOICE_RECEIVED = 'INVOICE_RECEIVED',
  ONGOING_COST_CONTROL = 'ONGOING_COST_CONTROL',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  SUPPLIER_PAID = 'SUPPLIER_PAID',
  CHARGED = 'CHARGED'
}

export enum SupplierInvoiceStatus {
  invoiceReceived = 'INVOICE_RECEIVED',
  awaitingAccounting = 'AWAITING_ACCOUNTING',
  invoiceCorrected = 'INVOICE_CORRECTED',
  ongoingCostControl = 'ONGOING_COST_CONTROL',
  rejected = 'REJECTED',
  approved = 'APPROVED',
  supplierPaid = 'SUPPLIER_PAID',
  customerCharged = 'CHARGED'
}
